import { Link, useParams } from 'react-router-dom';
import BrandLogo from '../components/BrandLogo';
import { certificatePages } from '../data/websiteContent';
import '../styles/MarketingPages.css';

const CertificateDetailPage = () => {
  const { slug } = useParams();
  const page = certificatePages.find((item) => item.slug === slug?.replace('.html', '')) ?? certificatePages[0];

  return (
    <div className="marketing-page">
      <section className="detail-layout">
        <div className="detail-visual" style={{ '--accent': page.accent } as React.CSSProperties}>
          <BrandLogo compact />
          <span className="eyebrow-pill">Certificate</span>
          <h1>{page.title}</h1>
          <p>{page.subtitle}</p>
          <div className="detail-badge">{page.slug}.html</div>
          <div className="detail-metrics">
            <div>
              <strong>Scope</strong>
              <span>Defined activities</span>
            </div>
            <div>
              <strong>Status</strong>
              <span>Verification ready</span>
            </div>
          </div>
        </div>

        <div className="content-card">
          <h2>Overview</h2>
          <p>{page.summary}</p>
          <h3>Highlights</h3>
          <ul>
            {page.bullets.map((bullet) => (
              <li key={bullet}>{bullet}</li>
            ))}
          </ul>
          <div className="info-box detail-notes">
            <h3>Best for</h3>
            <p>Organizations that want a clear certificate presentation and a public verification journey.</p>
          </div>
          <div className="page-actions">
            <Link to="/verify" className="btn btn-secondary">
              Verify Certificate
            </Link>
            <Link to="/contact" className="btn btn-primary">
              Request Information
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CertificateDetailPage;
